import { post } from "@/api/common/request";

/**
 * 通用文件上传
 * 后端接口：/common/upload
 * 传参字段：code / fileName / file（multipart/form-data）
 */
export function uploadCommonFile(file, filename, extra = {}) {
  if (!file) {
    throw new Error("uploadCommonFile: file is required");
  }

  const formData = new FormData();
  const finalName = filename || (file && file.name ? file.name : `upload_${Date.now()}`);
  const code = extra.code || "huaweiobs";

  
  // 按接口约定固定字段：code / fileName / file（二进制）
  formData.append("code", code);
  formData.append("fileName", finalName);
  formData.append("file", file);

  console.log(file, 'file>>>>>')
  console.log(formData, 'file>>>>>')

  return post("/common/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data;charset=utf-8",
    },
  });
}

